import React, { Component } from 'react';
import './home.css';
import ScrollToTop from '../shared-components/scroll-top';
import StarRating from '../shared-components/star-rating';
import skills from '../shared-components/skills';

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      yAxisPageValue: 0
    };
    this.parallaxScroll = this.parallaxScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.parallaxScroll);
  };
  
  componentWillUnmount() {
    window.removeEventListener('scroll', this.parallaxScroll);
  };

  parallaxScroll() {
    this.setState(state => ({
      yAxisPageValue: window.pageYOffset
    }));
    
    const parallaxElement = document.querySelector('.parallax-element-home-hello');
    parallaxElement.style.backgroundPositionY = (this.state.yAxisPageValue * 0.1) + 'px';
  }

  render() {
    return (
      <div className="mainContainer">

        <div className="parallax-element-home-hello">
          <div className="parallax-container-wrapper">
            <div className="hello-word">
              <h2> 
                Hello World !!!
                <br />
                I'm <span style={{'color': '#1554ad', 'fontWeight': '500'}}>Vasanth Kumar</span>
              </h2>
              <p> Software Engineer from India living in Hyderabad.</p>
            </div>
            <ScrollToTop />
          </div>          
        </div>

        <div className="parallax-element-home-skills">
          <div className="parallax-sub-container-wrapper">
            <div>
              <h4 className="align-center section-header">Primary skills</h4>
              <div className="skill-container">
                {
                  skills.primary.map(function(item) {
                    return(
                      <div key={item.id} className="skill-wrapper">
                        <div className="skill-title">{item.title}</div>
                        <div className="skill-image-rating-wrapper"> 
                          <div>
                            <img className="skill-logo" src={require(`../assets/${item.path}`)} alt={item.alt} />
                          </div>
                          <div className="star-rating">
                            <StarRating rating={item.rating} />
                          </div>
                        </div>
                      </div>
                    );
                  })
                }    
              </div>  
            </div>            
          </div>
          
          <div className="parallax-sub-container-wrapper">
            <div>
              <h4 className="align-center section-header">Secondary skills</h4>
              <div className="skill-container">
                {
                  skills.secondary.map(function(item) {
                    return(
                      <div key={item.id} className="skill-wrapper">
                        <div className="skill-title">{item.title}</div>
                        <div className="skill-image-rating-wrapper"> 
                          <div>
                            <img className="skill-logo" src={require(`../assets/${item.path}`)} alt={item.alt} />
                          </div>
                          <div className="star-rating">
                            <StarRating rating={item.rating} />
                          </div>
                        </div>
                      </div>
                    );
                  })
                }    
              </div>  
            </div>            
          </div>
        </div>
      </div>
    )
  }
}

export default Home;